<template>
    <el-container>
        <el-header>
            <commonheader :isNavShow='true'></commonheader>
        </el-header>

        <el-container class="el-container-master">
            <el-aside style="width:220px">
                <leftMenu></leftMenu>
            </el-aside>
            <el-main>
                <section class="flex">
                    <exit></exit>
                    <div class="content myInfo">
                        <el-row class="b0">
                            <el-col>
                                <label>学年：</label>
                                <span>{{netClassPayData.year}}年</span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col>
                                <label>课程名称：</label>
                                <span>{{netClassPayData.year}}年远程年度培训订单</span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span='18'>
                                <label>课程详情：</label>
                            </el-col>
                            <el-col :span='4' :offset='2'>
                                <el-button type="primary" :loading='watchLoading' class="watch" @click="watchClass">查 看</el-button>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span='4'>
                                <label>选择支付方式：</label>

                            </el-col>
                            <el-col :span='4'>
                                <el-col>
                                    <img width="60" src="../../../assets/images/wechat.png" alt="">
                                </el-col>
                                <el-col>
                                    <img width="60" src="../../../assets/images/alipay.png" alt="">
                                </el-col>
                            </el-col>
                            <el-col :span='4' :offset=12 v-if='loading'>
                                <el-radio-group class="payTypeRadio" v-model="payType">
                                    <el-radio :label='3'></el-radio>
                                    <el-radio :label='2'></el-radio>
                                </el-radio-group>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span='18'>
                                <label>价格：</label>
                            </el-col>
                            <el-col :span='4' :offset='2'>
                                <span class="price">¥{{netClassPayData.price}}</span>
                            </el-col>
                        </el-row>
                        <el-row class="b0">
                            <el-col :span='24'>
                                <label>温馨提示：</label>
                            </el-col>
                            <el-col :span='24'>
                                <label class="gray">1.学员缴费成功后，请抓紧时间学习。成功缴费1个月以上或已开始课程学习的，非系统原因将不再办理退费手续。</label>
                            </el-col>
                            <el-col :span='24'>
                                <label class="gray">2.完成选课但未完成缴费的，可在“我的订单”中查阅未完成订单。逾期未完成订单者，系统可能予以删除订单记录。</label>
                            </el-col>
                            <el-col :span='24'>
                                <label class="gray">3.已参加单位集体缴费的学员，无需再进行个人缴费。选完课程后，等待系统后台确认后即可开始课程学习。</label>
                            </el-col>
                            <el-col :span='24'>
                                <label class="gray">4.对于学员因“代学代办”“挂学假学”或平台以外的私下交易等原因造成的“学习档案审核未通过”，平台不予退费。</label>
                            </el-col>
                        </el-row>
                        
                        <el-row class="b0">
                            <el-col :offset='9'>
                                <el-button type="primary" :loading='payLoading' @click="openBox" class="btn">确认支付</el-button>
                            </el-col>
                        </el-row>

                        <wechat-pay :qrcode='qrcode' :isCurPay=curPay @closeCurPay='closeCurPay'></wechat-pay>
                    </div>

                    <el-dialog center title='购课列表' :visible.sync="isWatchClass" class="payClassList" width="305px"
                        :show-close='false'>
                        <div class="tips">
                            <el-row>
                                <el-col class="classItem" :span='24' v-for='(item,index) in classList' :key='index' >{{item.name}}</el-col>
                            </el-row>
                        </div>
                        <el-row class="footer-but">
                            <el-col :span="24">
                                <div class="grid-content bg-purple-dark sure" @click="isWatchClass=false">确定</div>
                            </el-col>
                        </el-row>
                    </el-dialog>

                    <div v-html="alipayWap" ref="alipayWap"></div>

                </section>
            </el-main>
        </el-container>

    </el-container>

</template>
<script>
import commonheader from "../../common/commonHeader.vue"; //头部组件
import leftMenu from "../../common/leftMenu.vue";
import exit from "../../common/exit.vue";
import wechatPay from "./wechatPay.vue";
export default {
    // name: 'index',
    components: {
        commonheader,
        leftMenu,
        exit,
        wechatPay
    },
    data () {
        return {
            watchLoading:false,//查看课程按钮loading
            payLoading:false,//支付按钮loading
            dengmiQueryForm: {},
            payType: 3,
            curPay: false,
            netClassPayData: {},
            alipayWap: '',
            qrcode: '',
            timer: null,
            order_id: '',
            classList: [],
            isWatchClass:false,
            loading:false,
        }
    },
    mounted: function () {
        document.getElementsByTagName("html")[0].className = "my-page";

        setTimeout(()=>{
            this.loading = true;
        },500)
        // console.log(this.payType);
        // this.$set();
        // this.payType = 3;
        this.netClassPayData = JSON.parse(localStorage.getItem('netClassPayData'))
    },
    methods: {
        /**
         * 查看课程
         */
        watchClass () {
            let params = {
                order_id: this.netClassPayData.order_id
            };
            if( this.classList.length ){
                this.isWatchClass = true;
                return false;
            }

            if( !params.order_id ){
                if( localStorage.getItem('selectedCourseList') ){
                    this.classList = JSON.parse(localStorage.getItem('selectedCourseList'));
                    this.isWatchClass = true;
                    return false;
                }
            }
            
            this.watchLoading = true;
            this.$store.dispatch('order_detail', params).then((res) => {
                // res.data = [...res.data,...res.data];
                if (res.code == 200) {
                    this.classList = res.data;
                    this.isWatchClass = true;
                }
                this.watchLoading = false;
            }).catch(()=>{
                this.watchLoading = false;
            })
        },
        openBox () {
            this.payLoading = true;
            let params = this.netClassPayData;
            params['pay_type'] = this.payType;

            this.$store.dispatch('order', params).then((res) => {
                console.log(res)
                if (res.code == 200) {
                    if (this.payType == 3) {
                        this.qrcode = res.data.orderSig.qrcode_url
                        this.curPay = true;
                        this.orderStatus(res.data.order_id);
                    } else {
                        window.location.href = res.data.orderSig;
                    }
                }
                this.payLoading = false;
            }).catch(error=>{
                this.payLoading = false;
            })
        },
        closeCurPay () {
            this.curPay = false;
        },
        /**
         * 微信支付查询订单状态
         */
        orderStatus (id) {
            clearInterval(this.timer);
            this.timer = setInterval(() => {
                //1 未支付 2 支付成功  3 支付失败  4 订单已取消  5 退款审核中  6退款成功 7 退款失败
                this.$store.dispatch('order_status', { order_id: id }).then((res) => {
                    if (res.code == 200) {
                        if (res.data.pay_status == 2) {
                            this.$message('支付成功');
                            clearInterval(this.timer);
                            setTimeout(() => {
                                this.$router.push('/myCourse');
                            }, 2000)
                        } else if (res.data.pay_status == 3) {
                            this.$message('支付失败，请刷新重试');
                            clearInterval(this.timer);
                        }
                    }
                }).catch(() => {
                    clearInterval(this.timer);
                })
            }, 3000)
        },
        beforeDestroy () {
            clearInterval(this.timer);
        },
    }
}
</script>

<style lang="stylus" scoped>
@media (min-width: 1399px)
    .el-container-master
        width 1400px
        margin auto
.el-aside
    background #fff
.el-main
    padding 0
    background #fff
.content
    padding 47px 189px 0 84px
    flex 1
    border-top 10px solid #F8F8F8
    border-left 10px solid #F8F8F8
    padding-bottom 50px
    color #333
    &>.el-row
        padding 13px 0
        border-bottom 1px solid #F8F8F8
        .price
            color $textColorRed
            // margin-left 15px
        .gray
            color $textColorGray
        .watch
            border 1px solid #0173FF
            color #0173FF
            background none
            font-weight normal
    .el-row.b0
        border 0
    .btn
        width 290px
        background-image $btnBg
        border 0
        background-size 100% 100%
        margin-top 70px
        &:hover
            background-image $btnBg
            background-size 100% 100%
.tips
    max-height 60vh
    overflow-y auto
    .classItem
        border-bottom 1px solid #ccc
        line-height 30px
        font-size 16px
</style>
<style lang="stylus">
.payClassList
    .el-dialog__header
        // display:none
    .el-dialog
        width 500px!important
        border-radius 8px
    .sure
        width 100px
        height 30px
        line-height 30px
        color #fff!important
        text-align center
        margin 20px auto 0
        padding 0
        background-image $btnBg
        background-size 100% 100%
        border-radius 4px
.payTypeRadio .el-radio
    // height: 30px;
    // line-height:30px;
    color transparent
    display block
    margin-top 30px
    margin-left 30px
    margin-right 30px
    &:last-child
        margin-right 30px !important
    .el-radio__label
        color transparent !important
    .el-radio__input
        display none
    &:after
        content ''
        display block
        height 26px
        width 26px
        background-image url('../../../assets/images/radio.png')
        background-size 100%
        position absolute
        right 0
        top 0
    &.is-checked
        color transparent
        position relative
        &:after
            content ''
            display block
            height 26px
            width 26px
            background-image url('../../../assets/images/radioSelected.png')
            background-size 100%
            position absolute
            right 0
            top 0
</style>


// WEBPACK FOOTER //
// src/components/my/pay/index.vue